'use client';

import { Suspense } from 'react';
import {
  StoneFAQSection,
  StoneInvestmentContactSection,
} from '@routeroyal/theme-stone-investment';

type Props = {
  locale: string;
  messages: Record<string, unknown>;
  organisationId?: string;
};

/**
 * Stone Investment Contact Content
 * 
 * Uses the Concept One Contact design with:
 * - Editorial header with title
 * - Contact form with animated underlines
 * - Partner cards
 * - Interactive map images
 */
export function ContactContentStone({ locale, messages, organisationId }: Props) {
  return (
    <>
      <Suspense fallback={null}>
        <StoneInvestmentContactSection
          locale={locale}
          messages={messages}
          {...(organisationId ? { organisationId } : {})}
        />
      </Suspense>
      <StoneFAQSection
        source="contact"
        locale={locale}
        messages={messages}
        className="bg-white"
      />
    </>
  );
}
